import { media } from './media.model';
import { artist } from './artist.model';
export class album {
  id: number;
  title: string;
  category: string;
  cover_url: string;
  artists: artist[];
  artist_string: string;
  price: number;
  medias: media[];
}



// WEBPACK FOOTER //
// ./src/models/album.model.ts